import React, { FC } from 'react';
import styled from 'styled-components';

const _InfoIconAccountMenu: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} width='20' height='20' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M10 3.4231C8.62549 3.4231 7.5 4.54858 7.5 5.9231C7.5 7.29761 8.62549 8.4231 10 8.4231C11.3745 8.4231 12.5 7.29761 12.5 5.9231C12.5 4.54858 11.3745 3.4231 10 3.4231ZM10 4.6731C10.6982 4.6731 11.25 5.22485 11.25 5.9231C11.25 6.62134 10.6982 7.1731 10 7.1731C9.30176 7.1731 8.75 6.62134 8.75 5.9231C8.75 5.22485 9.30176 4.6731 10 4.6731ZM6.875 9.0481V12.1731H8.125V15.2981H6.875V18.4231H13.125V15.2981H11.875V9.0481H6.875ZM8.125 10.2981H10.625V16.5481H11.875V17.1731H8.125V16.5481H9.375V10.9231H8.125V10.2981Z'
            fill='#000000'
        />
    </svg>
);

const InfoIconAccountMenu = styled(_InfoIconAccountMenu)``;

export default InfoIconAccountMenu;
